/**
 * Format seconds to MM:SS display
 */
export function formatTimeMMSS(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format seconds to HH:MM:SS display
 */
export function formatTimeHHMMSS(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format seconds to human readable duration (e.g., "1 Min 30 Sek")
 */
export function formatDurationReadable(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  if (mins === 0) {
    return `${secs} Sek`;
  }
  if (secs === 0) {
    return `${mins} Min`;
  }
  return `${mins} Min ${secs} Sek`;
}

/**
 * Format interval to readable string (e.g., "5 Min" or "3:30 Min")
 */
export function formatIntervalReadable(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  if (secs === 0) {
    return `${mins} Min`;
  }
  return `${mins}:${secs.toString().padStart(2, '0')} Min`;
}

/**
 * Format timestamp to local time (HH:MM)
 */
export function formatTimeOfDay(timestamp: string | Date): string {
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return date.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Format timestamp to local time with seconds (HH:MM:SS)
 */
export function formatTimeOfDayWithSeconds(timestamp: string | Date): string {
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return date.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
